export const EXTERNAL_NETWORK_SETTINGS_TABS = {
  GENERAL: 'general',
  BUSINESS_PROFILE: 'businessProfile',
  ASSETS: 'assets',
  CLOUD_ACCOUNTS: 'cloudAccounts',
  WEB_APPS: 'webApps',
  DNS_ZONES: 'dnsZones',
  AUTOMATIONS: 'automations',
  DANGER: 'danger',
} as const;

export type ExternalNetworkSettingsTabId =
  (typeof EXTERNAL_NETWORK_SETTINGS_TABS)[keyof typeof EXTERNAL_NETWORK_SETTINGS_TABS];

export type ExternalNetworkSettingsTabAccess = {
  isConnectorSurface: boolean;
  isCloudInventoryEnabled: boolean;
  isWebAppDraftsEnabled: boolean;
  isDnsZoneSyncEnabled: boolean;
  canManageApplications: boolean;
};

const ASSETS_FALLBACK_TABS: readonly ExternalNetworkSettingsTabId[] = [
  EXTERNAL_NETWORK_SETTINGS_TABS.BUSINESS_PROFILE,
  EXTERNAL_NETWORK_SETTINGS_TABS.CLOUD_ACCOUNTS,
  EXTERNAL_NETWORK_SETTINGS_TABS.DNS_ZONES,
];

export const getVisibleExternalNetworkSettingsTabs = ({
  isConnectorSurface,
  isCloudInventoryEnabled,
  isWebAppDraftsEnabled,
  isDnsZoneSyncEnabled,
  canManageApplications,
}: ExternalNetworkSettingsTabAccess): ExternalNetworkSettingsTabId[] => [
  EXTERNAL_NETWORK_SETTINGS_TABS.GENERAL,
  ...(isConnectorSurface
    ? []
    : [EXTERNAL_NETWORK_SETTINGS_TABS.BUSINESS_PROFILE]),
  EXTERNAL_NETWORK_SETTINGS_TABS.ASSETS,
  ...(isCloudInventoryEnabled && !isConnectorSurface
    ? [EXTERNAL_NETWORK_SETTINGS_TABS.CLOUD_ACCOUNTS]
    : []),
  ...(isWebAppDraftsEnabled ? [EXTERNAL_NETWORK_SETTINGS_TABS.WEB_APPS] : []),
  ...(isDnsZoneSyncEnabled && !isConnectorSurface
    ? [EXTERNAL_NETWORK_SETTINGS_TABS.DNS_ZONES]
    : []),
  EXTERNAL_NETWORK_SETTINGS_TABS.AUTOMATIONS,
  ...(canManageApplications ? [EXTERNAL_NETWORK_SETTINGS_TABS.DANGER] : []),
];

export const resolveExternalNetworkSettingsActiveTab = ({
  activeTab,
  visibleTabs,
}: {
  activeTab: string;
  visibleTabs: readonly ExternalNetworkSettingsTabId[];
}): ExternalNetworkSettingsTabId => {
  const visibleTab = visibleTabs.find((tab) => tab === activeTab);

  if (visibleTab) {
    return visibleTab;
  }

  return ASSETS_FALLBACK_TABS.some((tab) => tab === activeTab)
    ? EXTERNAL_NETWORK_SETTINGS_TABS.ASSETS
    : EXTERNAL_NETWORK_SETTINGS_TABS.GENERAL;
};
